import createTransition from 'shared-tokens/utils/createTransition';
import colors from 'shared-tokens/utils/tokens/colors';
import shadows from 'shared-tokens/utils/tokens/shadows';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

export const mainCls = 'input-field';
const colorF2 = colors.f2.rgba;
const colorF3 = colors.f3.rgba;
const colorBrFc = '#6a7785';
const colorLine = '#D8DBDF';
const borderGut = 12;

const brpS = createBreakpoint('s');

export default {
    [mainCls]: {
        border: `1px solid ${colorLine}`,
        color: colors.w.rgba,
        paddingRight: borderGut,
        paddingLeft: borderGut,
        transition: createTransition(['box-shadow', 'min-height', 'border-color']),
        '& .pwd': {
            color:colors.f3.rgba,
        },
        [brpS]: {
            '&:hover': {
                borderColor: colorBrFc,
                '& .pwd': {
                    color:colors.f1.rgba,
                },
                [`& .${mainCls}__close`]: {
                    opacity: 1,
                },
            }
        },

        '&.sizec-h--m': {
            '& .input-field__inp': {
                lineHeight: '38px',
            },
        },
        '&.sizec-h--l': {
            '& .input-field__inp': {
                lineHeight: '42px',
            },
        },
        '&.sizec-h--xl': {
            '& .input-field__inp': {
                lineHeight: '46px',
            },
        },
        '&.sizec-h--x2l': {
            '& .input-field__inp': {
                lineHeight: '50px',
            },
        },
        '&.sizec-h--x3l': {
            '& .input-field__inp': {
                lineHeight: '54px',
            },
        },
    },
    [`${mainCls}__inp`]: {
        outline: 'none',
        display: 'block',
        lineHeight: '2.2rem',
        verticalAlign: 'middle',
        caretColor: '#0981f9',
        color: '#1a1f24',
        width: '100%',
        border: 'none',
        textOverflow: 'ellipsis',
        backgroundColor: 'transparent',
        padding: 0, // iOS fix
        margin: 0, // iOS fix
        boxShadow: 'none', // Removes invalid red border in Firefox

        '&::placeholder': { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: colorF2,
            opacity: 1, /* Firefox */
            [brpS]: {
                color: colorF3,
            },
        },
        '&:-ms-input-placeholder': { /* Internet Explorer 10-11 */
            color: colorF2,
            [brpS]: {
                color: colorF3,
            },
        },
        '&::-ms-input-placeholder': { /* Microsoft Edge */
            color: colorF2,
            [brpS]: {
                color: colorF3,
            },
        },
        '&::-ms-clear': { /* Hide clear icon in Microsoft Edge */
            display: 'none',
        },
        
        '&:-webkit-autofill': {
            '-webkit-box-shadow': '0 0 0 30px white inset !important',
            'background-clip': 'content-box !important',
            'background-color': '#FFF !important',
        },
    },

    [`${mainCls}__inp-plh`]: {
        pointerEvents: 'none',
        position: 'absolute',
        left: 0,
        top: 0,
        opacity: 0.5,
    },
    [`${mainCls}--focus`]: {
        borderColor: colorBrFc,
        boxShadow: `4px 4px 6px -1px ${shadows.shadowColor.rgba}`,
    },
    [`${mainCls}--valued`]: {
        borderColor: colorF3,
    },

    [`${mainCls}--unstl`]: {
        border: 'none',
        boxShadow: 'none',
    },
    [`${mainCls}__close`]: {
        opacity: 0,
        '&:hover': {
            opacity: 1,
        },
    },
    [`${mainCls}__close--shw`]: {
        opacity: 1,
    },
}